import { render, staticRenderFns } from "./plafon.vue?vue&type=template&id=e2f4b7b2"
import script from "./plafon.vue?vue&type=script&lang=js"
export * from "./plafon.vue?vue&type=script&lang=js"
import style0 from "./plafon.vue?vue&type=style&index=0&id=e2f4b7b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports